import { IActivity } from '@sdk/contracts';
import { Checkbox } from 'antd';

import { ActivityName, Wrapper } from './ActivityItem.styles';

import { Icon } from '@/components/Icon';
import { ACTIVITY_ICONS } from '@/constants';

type ActivityItemProps = {
  activity: IActivity;
  isSelected: boolean;
  onCheckboxChange: (activity: IActivity, checked: boolean) => void;
};

export const ActivityItem: React.FC<ActivityItemProps> = ({
  activity,
  isSelected,
  onCheckboxChange
}) => (
  <Wrapper>
    <Checkbox checked={isSelected} onChange={e => onCheckboxChange(activity, e.target.checked)} />
    <Icon i={ACTIVITY_ICONS[activity.type]} />
    <ActivityName>{activity.name}</ActivityName>
  </Wrapper>
);
